import React, { useState } from "react";

function CarpetRemovalFAQs() {
  const [openAccordionIndex, setOpenAccordionIndex] = useState(null);

  const toggleAccordion = (index) => {
    // Toggle the current accordion's open state
    setOpenAccordionIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const accordionItems = [
    {
      title: "How much does carpet removal cost?",
      content: `
        Pricing depends on the square footage and condition of the carpet. We provide free estimates with upfront pricing.
      `,
    },
    {
      title: "Can I remove carpet myself?",
      content: `
       Yes, but it requires tools like a utility knife, pry bar, knee pads, and safety gear. Cutting carpet into manageable sections or strips with a sharp-bladed floor scraper and duct tape can help. However, hiring professionals ensures a hassle-free experience and proper disposal.
      `,
    },
    {
      title: "Do you remove carpet from concrete or wood subfloors?",
      content: `
       Yes! Our team is equipped to handle carpet removal from all types of subfloors, including concrete floors and wood subfloors.
      `,
    },
    {
      title: "What happens to the removed carpet?",
      content: `
         We recycle whenever possible and dispose of other materials in an eco-friendly manner.
        `,
    },
    {
      title: "How do I schedule carpet removal services?",
      content: `
         Simply call or message us for a free quote, choose a time, and let us handle the rest!
        `,
    },
  ];

  return (
    <div>
      <main>
        <div className="accordion">
          {accordionItems.map((item, index) => (
            <div className="accordion-item" key={index}>
              <div
                className="accordion-item-header"
                onClick={() => toggleAccordion(index)}
                style={{ cursor: "pointer" }}
              >
                <span className="accordion-item-header-title">
                  {item.title}
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                  />
                </svg>
              </div>
              <div
                className="accordion-item-description-wrapper"
                style={{
                  display: openAccordionIndex === index ? "block" : "none",
                }}
              >
                <div className="accordion-item-description furniture-faq">
                  <hr />
                  <p>{item.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default CarpetRemovalFAQs;
